"use client";
import { useFormStatus } from "react-dom";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";

import Button from "../button";

type SubmitButtonProps = {
  icon: IconDefinition;
  rightAlign?: boolean;
  text: string;
  submittingText: string;
  testId?: string;
};

export default function SubmitButton({
  icon,
  rightAlign,
  text,
  submittingText,
  testId,
}: SubmitButtonProps) {
  const status = useFormStatus();

  if (status.pending) {
    return (
      <Button
        icon={faSpinner}
        disabled
        rightAlign={rightAlign}
        type="positive"
        href="/"
        data-testid={testId}
      >
        {submittingText}
      </Button>
    );
  }

  return (
    <Button
      icon={icon}
      submit
      rightAlign={rightAlign}
      type="positive"
      href="/"
      data-testid={testId}
    >
      {text}
    </Button>
  );
}
